import React, { useEffect, useState } from "react";
import "./css.css";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { db } from "../config_firebase";
import {
    collection,
    addDoc,
    getDocs,
    doc,
  } from "firebase/firestore";

/**
 * @author
 * @function Login
 *
 **/

 export const Transition = (props) => {
    // const [pic, setPic] = useState(img1);
    const history = useNavigate();
    const [url, setUrl] = useState(window.location.href);
    const [userId, setUserId] = useState("");

    useEffect(() => {
        const iosa = url.split(",");
        setUserId(iosa[1]);
      }, []);

    async function addclick(data) {
    const docRef = await addDoc(collection(db, "clicksdata"), {
        data,
     });
    }

    const next = () => {
        const transition_button = {
            time: Date.now(),
            userId: localStorage.getItem("user_id"),
            buttonType: "transition_button",
        };
        addclick(transition_button);

        var parsedArray = JSON.parse(localStorage.getItem("random_array"));
        history(`/page${parsedArray[0]}/?,${userId}`);
        parsedArray.shift();
        localStorage.setItem("random_array",JSON.stringify(parsedArray));
    }
    
    return(
        <div className="main">
            <div className="text-center">
                <div className="content">
                    <h3 className="transition">Click on the "Next" button to continue to the next stock.</h3>
                </div>
                <div>
                    <Button variant="outline-light" className="instructionsnextbutton" onClick={next}>Next</Button>
                </div>
            </div>
        </div>
    );
}